import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiMe, apiLogin, apiRegister, apiLogout } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading/none
  const [checking, setChecking] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const u = await apiMe();
      setUser(u);
      return u;
    } catch (e) {
      console.warn("refreshUser failed:", e?.message || e);
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem("fn_token")) await refreshUser();
      setChecking(false);
    })();
  }, [refreshUser]);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem("fn_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const data = await apiRegister(email, password, name);
    localStorage.setItem("fn_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await apiLogout(); } catch (e) { console.warn("logout request failed:", e?.message || e); }
    localStorage.removeItem("fn_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, checking, refreshUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
